var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.progress < 100)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":"/img/xj/loading.gif","alt":""}}),_c('p',[_vm._v("穿越中 "+_vm._s(_vm.progress)+"%")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }